import firebase from "firebase/app";
import "firebase/firestore";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyBKbwVYaBY_De5eOW5e3bCyJhr5wzdpIk0",
  authDomain: "thrive-hogans.firebaseapp.com",
  projectId: "thrive-hogans",
  storageBucket: "thrive-hogans.appspot.com",
  messagingSenderId: "287868034144",
  appId: "1:287868034144:web:1d447e891d279c2e7d7705",
  measurementId: "G-BZ36TQL7M4",
};

const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({});
export default firebaseApp.firestore();
